import { AxDataTable } from "@/components/ax/dataTable/AxDataTable";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { ROUTES } from "@/constants/routeConstants";
import { HospitalityMenu } from "@/lib/types";
import { getHospitalityMenu } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { ViewRowButton } from "@/components/ax/dataTable/ViewRowButton";
import { AddRowButton } from "@/components/ax/dataTable/AddRowButton";
import { PermissionChecker2 } from "@/components/permission/PermissionChecker2";

export const HospitalityMenuPage = () => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);
  const { goToHospitalityMenuDetail, goToHospitalityMenuAdd } = useAppNavigate();

  useBreadcrumbs([
    {
      name: t("entities.hospitalityMenu"),
      path: ROUTES.HOSPITALITY_MENU,
    },
  ]);

  const columns: ColumnDef<HospitalityMenu>[] = [
    {
      accessorKey: "name",
      header: t("common.name"),
    },
    {
      accessorKey: "currencyName",
      header: t("entities.currency"),
    },
    {
      accessorKey: "store",
      header: t("entities.store"),
    },
    {
      accessorKey: "pushId",
      header: t("hospitalityMenu.pushId"),
    },
    {
      accessorKey: "lastSync",
      header: t("hospitalityMenu.lastSync"),
    },
    {
      accessorKey: "id",
      header: () => "",
      cell: ({ row }) => {
        return (
          <PermissionChecker2 entity="HMenu" rights={["GetDetails"]}>
            <div className="flex items-center justify-end gap-2">
              <ViewRowButton onClickView={() => goToHospitalityMenuDetail(row.original.id)} />
            </div>
          </PermissionChecker2>
        );
      },
    },
  ];
  return (
    <div className="flex gap-4">
      <AxDataTable
        columns={columns}
        fetcher={getHospitalityMenu}
        getRowId={(row) => row.id.toString()}
        uniqQueryKey={"getHospitalityMenu"}
        dynamicRequestParams={{ firmId: String(activeFirm?.firmGuid) }}
        extraHeader={
          <PermissionChecker2 entity="HMenu" rights={["Add"]}>
            <AddRowButton
              title={t("common.addNewEntity", { entity: t("entities.hospitalityMenu") })}
              onClickAdd={goToHospitalityMenuAdd}
            />
          </PermissionChecker2>
        }
      />
    </div>
  );
};
